import { Component, Input } from '@angular/core';
import { ScormPackageProgressionModel } from 'src/models/scormPackageProgressionModel';
import { EProgressionPaquet } from 'src/enum/eProgressionPaquet';
import { MatIconModule } from '@angular/material/icon';


@Component({
    selector: 'app-scorm-package-card',
    templateUrl: './scorm-package-card.component.html',
    styleUrls: ['./scorm-package-card.component.scss'],
    imports: [
    MatIconModule
]
})
export class ScormPackageCardComponent {
  @Input() scormPackage!: ScormPackageProgressionModel;
  @Input() getLocalizedContent!: (locales: any[]) => any;
  @Input() showDescription!: (scormPackage: any) => void;
  @Input() shouldShowProgressionIcon!: (pkg: ScormPackageProgressionModel) => boolean;
  EProgressionPaquet = EProgressionPaquet;
}
